import Users from './Users'

const getUser = async () => {
  const { data } = await Users().me().show({})
  return data
}

export default getUser
